import "./incentive.scss"
import "./static/incentive-desktop.png"
import "./static/incentive-mobile.png"
import "./static/incentive-desktop.webp"
import "./static/incentive-mobile.webp"

import { showSignup } from "components/signup"
import { track } from "utils/analytics"
import observeTouchpointExposure from "utils/touchpoint-exposure"

declare global {
  interface Window {
    FCGON?: {
      logged_in?: boolean
      is_app?: boolean
    }
  }
}

function signupOptionsFor(form: HTMLFormElement) {
  const data = new FormData(form)
  const initialOffer = data.get("incentive_offer")
  const options: { initialOffer?: string; initialStep?: string } = {}

  if (typeof initialOffer === "string") {
    options.initialOffer = initialOffer
  }
  if (window.FCGON && window.FCGON.logged_in) {
    options.initialStep = "the-payment"
  }

  return options
}

function touchpointOf(form: HTMLFormElement) {
  return form.closest<HTMLElement>("[data-touchpoint]")?.dataset.touchpoint || "forecast_incentive"
}

function initIncentiveOffers(root: ParentNode = document) {
  const forms = Array.from(root.querySelectorAll<HTMLFormElement>(".js-incentive-offers"))

  forms.forEach((form) => {
    if (form.dataset.incentiveInitialized) return

    form.setAttribute("data-incentive-initialized", "true")
    form.addEventListener("submit", (event) => {
      event.preventDefault()
      showSignup({ ...signupOptionsFor(form), touchpoint: touchpointOf(form) })
    })
  })
}

function eventForIncentiveClick(target: EventTarget | null) {
  if (!(target instanceof Element)) return null
  if (target.closest(".incentive__submit")) return "incentive_continue_click"
  if (target.closest(".incentive__offer")) return "incentive_offer_click"

  return null
}

function initIncentiveClickTracking(root: ParentNode = document) {
  const panels = Array.from(root.querySelectorAll<HTMLElement>(".incentive"))

  panels.forEach((panel) => {
    if (panel.dataset.clickTrackingInitialized) return

    panel.setAttribute("data-click-tracking-initialized", "true")
    panel.addEventListener("click", (event) => {
      const clickEvent = eventForIncentiveClick(event.target)
      if (clickEvent) track(clickEvent)
    })
  })
}

function initIncentive(root: ParentNode = document) {
  initIncentiveOffers(root)
  initIncentiveClickTracking(root)
  // The in-app webview (packs/app.js) opens the native paywall and has no GTM.
  if (!(window.FCGON && window.FCGON.is_app)) observeTouchpointExposure(root)
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initIncentive())
} else {
  initIncentive()
}
